export class LineWeights {
	static List: Array<number> = [1, 2, 3, 4, 5];
}
